import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { withRouter } from "react-router";
import userManagementService from "../../services/userManagementService";
import { getState } from "../../state/store";
import ToggleButton from "../../components/buttons/toggle_button";
import EditForm from "../../components/containers/edit_form";
import { FlexRowCenter } from "../../components/containers/styled";
import { FieldContainer } from "../../components/inputs/field_container";
import InputForProperty from "../../components/inputs/inputForProperty";
import SelectForProperty from "../../components/inputs/selectForProperty";
import Loader from "../../components/loader/loader";
import {FormBody} from "../../components/containers/form_body"

const emptyUser = {
    applicationUserId: "00000000-0000-0000-0000-000000000000",
    userName: "",
    password: "",
    confirmPass: "",
    firstName: "",
    secondName: "",
    email: "",
    isActive: true,
    roleName: "Admin"
};

const EditUser = (props) => {
    const { match, history, t } = props;
    const [isNewUser, setIsNewUser] = useState(true);
    const [user, setUser] = useState({ ...emptyUser })
    const [roleList, setRoleList] = useState(['Admin']);
    const [userNameError, setUserNameError] = useState(null);
    const [passwordError, setPasswordError] = useState(null);
    const [confirmPasswordError, setConfirmPasswordError] = useState(null);
    const [validationError, setValidationError] = useState(false);
    const [loading, setLoading] = useState(false);
    const roles = useSelector(state => state.roles.roles);
    const currentUserId = getState().app.user.userId;

    useEffect(() => {
        setLoading(true);
        const userId = match.params.id ? match.params.id : 0;
        getUser(userId);
    }, []);

    useEffect(() => {
        const rl = [];

        roles.forEach((item) => {
            rl.push({
                label: item.description,
                value: item.roleName
            })
        });

        setRoleList(rl);
    }, [roles])

    const getUser = async (userId) => {
        if (!userId) {
            setIsNewUser(true);
            setLoading(false);
            return;
        }
        const u = await userManagementService.getUserAsync(userId);
        setIsNewUser(false);
        setUser(u);
        setLoading(false);
    }

    const updateUserField = (propertyName, value) => {
        const us = { ...user };
        us[propertyName] = value;
        setUser(us);
        if (validationError) {
            validateFields(us);
        }
    }

    const validateFields = (userState) => {
        let isValid = true;
        if (isNewUser) {
            if (userState.password !== userState.confirmPass) {
                setPasswordError(t("UserManagement.passwordAndConfirmNotEqualsError"));
                setConfirmPasswordError(t("UserManagement.passwordAndConfirmNotEqualsError"));
                isValid = false;
            }
            else {
                setPasswordError(null);
                setConfirmPasswordError(null);
            }
        }
        else if ((userState.password || userState.confirmPass) && userState.password !== userState.confirmPass) {
            setPasswordError(t("UserManagement.passwordAndConfirmNotEqualsError"));
            setConfirmPasswordError(t("UserManagement.passwordAndConfirmNotEqualsError"));
            isValid = false;
        }
        else {
            setPasswordError(null);
            setConfirmPasswordError(null);
        }

        if (!userState.userName || userState.userName === '') {
            setUserNameError(t("UserManagement.userNameEmptyError"));
            isValid = false;
        } else {
            setUserNameError(null);
        }

        if (isValid !== !validationError) {
            setValidationError(!isValid);
        }

        return isValid;
    }

    const submit = async () => {
        try {
            if (!validateFields(user)) {
                return;
            }

            if (isNewUser) {
                await userManagementService.addUserAsync(user);
            }
            else {
                await userManagementService.updateUserAsync(user);
            }
            history.replace('/users');
        }
        catch (e) {

        }
        //history.replace('/users');
    }

    const cancel = async () => {
        history.replace('/users');
    }

    return (
        <EditForm submit={submit} cancel={cancel}>
            <FormBody>
                <FlexRowCenter>
                    <div>
                        <FieldContainer>
                            <InputForProperty header={t("UserManagement.userName")} validationError={userNameError} autoComplete="off" onChange={updateUserField}
                                value={user.userName} propertyName="userName" />ж
                        </FieldContainer>
                        <FieldContainer>
                            <SelectForProperty header={t("UserManagement.roleName")} onChange={updateUserField}
                                disabled={currentUserId === user.applicationUserId}
                                value={user.roleName} propertyName="roleName" options={roleList} />
                        </FieldContainer>
                        <FieldContainer>
                            <InputForProperty type="password"
                                header={isNewUser ? t("UserManagement.password") : t("UserManagement.newPassword")}
                                autoComplete="new-password" onChange={updateUserField}
                                validationError={passwordError}
                                value={user.password} propertyName="password" />
                        </FieldContainer>
                        <FieldContainer>
                            <InputForProperty type="password" header={t("UserManagement.confirmPassword")}
                                onChange={updateUserField}
                                validationError={confirmPasswordError}
                                value={user.confirmPass} propertyName="confirmPass" />
                        </FieldContainer>
                        <FieldContainer>
                            <InputForProperty header={t("UserManagement.firstName")} onChange={updateUserField}
                                value={user.firstName} propertyName="firstName" />
                        </FieldContainer>
                        <FieldContainer>
                            <InputForProperty header={t("UserManagement.secondName")} onChange={updateUserField}
                                value={user.secondName} propertyName="secondName" />
                        </FieldContainer>
                        <FieldContainer>
                            <InputForProperty header={t("UserManagement.email")} onChange={updateUserField}
                                value={user.email} propertyName="email" />
                        </FieldContainer>
                        <FieldContainer>
                            <label>{t("UserManagement.isActive")}</label>
                            <ToggleButton value={user.isActive} disabled={currentUserId === user.applicationUserId}
                                onChange={(checked) => updateUserField("isActive", checked)} />
                        </FieldContainer>
                    </div>
                </FlexRowCenter>
            </FormBody>
            {loading && <Loader />}
        </EditForm>
    )
}

export default withRouter(withTranslation("translations")(EditUser));